"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleDataUpdate = exports.SimpleDataPost = exports.SimpleDataPatch = exports.SimpleDataFetchWithPayload = exports.SimpleDataFetch = exports.SimpleDataDelete = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.json.stringify.js");
const SimpleDataFetch = _ref => {
  let {
    apiUrl
  } = _ref;
  return fetch(apiUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8'
    }
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataFetch = SimpleDataFetch;
const SimpleDataFetchWithPayload = _ref2 => {
  let {
    apiUrl,
    payload
  } = _ref2;
  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataFetchWithPayload = SimpleDataFetchWithPayload;
const SimpleDataPost = _ref3 => {
  let {
    apiUrl,
    payload
  } = _ref3;
  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataPost = SimpleDataPost;
const SimpleDataPatch = _ref4 => {
  let {
    apiUrl,
    payload
  } = _ref4;
  return fetch(apiUrl, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataPatch = SimpleDataPatch;
const SimpleDataUpdate = _ref5 => {
  let {
    apiUrl,
    payload
  } = _ref5;
  return fetch(apiUrl, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataUpdate = SimpleDataUpdate;
const SimpleDataDelete = _ref6 => {
  let {
    apiUrl,
    payload
  } = _ref6;
  return fetch(apiUrl, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(response => {
    return response.json();
  }).then(data => {
    return data;
  }).catch(error => {
    return error;
  });
};
exports.SimpleDataDelete = SimpleDataDelete;
var _default = exports.default = {
  SimpleDataPost,
  SimpleDataFetch,
  SimpleDataDelete,
  SimpleDataFetchWithPayload,
  SimpleDataPatch,
  SimpleDataUpdate
};